import ExportsPage from 'components/Exports';
import { FC, useState } from 'react';
import { connect } from 'react-redux';
import { setExportColumns, setTags } from 'store/actions/admin/mentorLists';
import { StoreState } from 'store/reducers';
import Tags from 'types/Tags';
import { Action } from 'types/typeguards/reducerActions';
import { apiURL } from 'utils/apiURL';
import { getIsMentorStatus } from 'utils/mentorTags';
import privateAPI from 'utils/privateAxiosInstance';
import getTagsQueryParams from 'utils/tagQueryParam';
import { TagColumnNames } from '.';

export const exportColumnNames = [
  'id',
  'Prénom',
  'Nom',
  'Prioritaire',
  'Adresse email',
  'Numéro de téléphone',
  'Chargé(e) de mentorat',
  'Organisme',
  "Date d'inscription",
  'Adresse',
  'Ville',
  'Pays',
  'Région',
  'Code postal',
  'Mentorats souhaités',
  'Mentorats en cours',
  'Statut du mentorat',
  "Recherche d'emploi",
  'Carrière',
  'Études',
  'Entreprenariat',
  'Domaines de compétence',
  'Formations adaptées',
  'Niveau de diplôme',
  'Mode de vie',
  'Passe temps',
  'Date du dernier entretien',
  'Accord pour un recontact INJEP',
] as const;
export type ExportColumn = typeof exportColumnNames[number];
export type ExportColumns = Record<ExportColumn, boolean>;
export const defaultExportColumns: ExportColumns = {
  id: false,
  Prénom: false,
  Nom: false,
  Prioritaire: false,
  'Adresse email': false,
  'Numéro de téléphone': false,
  'Chargé(e) de mentorat': false,
  Organisme: false,
  "Date d'inscription": false,
  Adresse: false,
  Ville: false,
  Pays: false,
  Région: false,
  'Code postal': false,
  'Mentorats souhaités': false,
  'Mentorats en cours': false,
  'Statut du mentorat': false,
  "Recherche d'emploi": false,
  Carrière: false,
  Études: false,
  Entreprenariat: false,
  'Domaines de compétence': false,
  'Formations adaptées': false,
  'Niveau de diplôme': false,
  'Mode de vie': false,
  'Passe temps': false,
  'Date du dernier entretien': false,
  'Accord pour un recontact INJEP': false,
};

type Props = {
  tags: Tags<TagColumnNames>;
  setTags: (tag: Tags<TagColumnNames>) => void;
  search: string;
  exportColumns: ExportColumns;
  setExportColumns: (exportColumns: ExportColumns) => void;
};
const Export: FC<Props> = ({
  tags,
  // setTags,
  search,
  exportColumns,
  setExportColumns,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');
  const handleDownload = () => {
    setLoading(true);
    privateAPI
      .get(
        `${apiURL}/exports/mentors?param=e${search ? `&search=${search}` : ''}\
${Object.entries(exportColumns)
  .map(([key, value]) => {
    return value ? `&columns=${key}` : '';
  })
  .join('')}\
		${
      tags.status[0]
        ? tags.status
            .map((tag) =>
              getIsMentorStatus(tag)
                ? `&mentorTags=${tag}`
                : `&mentorshipTags=${tag}`,
            )
            .join('')
        : ''
    }\
		${getTagsQueryParams<TagColumnNames>(tags, [
      'jobSearch',
      'careerPlan',
      'studies',
      'entrepreneurship',
      'expertiseFields',
      'formations',
      'diploma',
      'consideration',
      'hobby',
      'wantedMentorships',
    ])}`,
        { responseType: 'blob' },
      )
      .then((res) => {
        try {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'mentors.csv');
          document.body.appendChild(link);
          link.click();
        } catch {
        }
      })
      .catch(() => {
        try {
          window.scrollTo({ top: 0 });
        } catch {
        }
        setError('Une erreur est survenue.');
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <ExportsPage
      backTo="/admin/mentoring/mentors"
      pageTitle="Exporter la liste"
      // tagList={[
      //   {
      //     columnName: 'status',
      //     columnTitle: 'Statut du mentorat',
      //     tags: mentorTags.map((tag) => ({
      //       name: tag,
      //       label: MENTOR_STATUS[tag],
      //       labelComponent: <MentorStatusChip status={tag} />,
      //     })),
      //   },
      //   getJobSearchColumn('mentor'),
      //   getCareerPlanColumn('mentor'),
      //   getStudiesColumn('mentor'),
      //   getEntrepreneurshipColumn('mentor'),
      //   expertiseFieldsColumn,
      //   formationsColumn,
      //   diplomaColumn,
      //   considerationColumn,
      //   hobbyColumn,
      //   wantedMentorshipsColumn,
      // ]}
      // tags={tags}
      // setTags={setTags}
      columnList={exportColumnNames}
      columns={exportColumns}
      setColumns={setExportColumns}
      onDowload={handleDownload}
      loading={loading}
      error={error}
    />
  );
};

const mapStateToProps = (state: StoreState) => {
  return {
    tags: state.admin.mentorLists.main.tags,
    search: state.admin.mentorLists.main.search,
    exportColumns: state.admin.mentorLists.main.exportColumns,
  };
};

const mapDispatchToProps = (dispatch: (action: Action) => void) => {
  return {
    setTags: (tags: Tags<TagColumnNames>) =>
      dispatch(setTags<TagColumnNames>('main', tags)),
    setExportColumns: (exportColumns: ExportColumns) =>
      dispatch(setExportColumns('main', exportColumns)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Export);
